export default __webpack_public_path__ + "static/media/mar_lewc_seal2.24351c02.png";